import React from 'react';
import { CustomSvgIconButton } from 'crazyEditor/components/EditorUI/BaseUI/index';
import * as Colors from 'material-ui/styles/colors';

export default (props) => (
  <CustomSvgIconButton {...props} iconColor={props.checked ? '#ffffff' : Colors.grey700}
                                  iconBackground={props.checked ? Colors.grey700 : undefined}
                                  iconBackgroundWidth="32px" iconBackgroundHeight="32px"/>
);
